module.exports = __webpack_public_path__ + "media/images/athletes/2198-8cf2ec098669723c6297c3f5afedc1c1.png";